import useQueryIssueNotificationSettings from './useQueryIssueNotificationSettings';
import useMutationIssueNotificationSettings from './useMutationIssueNotificationSettings';

function useIssueNotificationSettings(args: { integrationId: number }) {
  const query = useQueryIssueNotificationSettings(args);
  const mutation = useMutationIssueNotificationSettings(args);

  return {
    isLoading: query.isLoading || mutation.isLoading,
    issueNotificationSettings: query.data,
    updateNotificationSettings: mutation.mutateAsync,
  };
}

export default useIssueNotificationSettings;
